<template lang="pug">
    div
        v-layout.mobileDirection(row wrap)
            v-flex(xs12 lg8)

                // Title
                title-component.noMargin(
                    title="My Practice"
                    slot="title"
                    type="h2"
                )

                div.pt-3
                    widgets(ref="widgets")


                div.userControls.my-3
                    div.mr-2.userControlsSelector
                        div.mr-2
                            span.userName {{ `${user.fullName.split(' ')[0]} `}}
                            span Practiced

                        // Periods
                        periods

                    div.text-sm-right(v-if="period === 'range'")

                        // Date range
                        range-component(
                            :id="id"
                            :rangeCallback="rangeCallback"
                        )

                            v-flex(xs12)

                div.mt-4.userMetrics
                    div.userMetric
                        div.userMetricTitle Minutes
                        div.userMetricTotal {{ minutesMeditated | numberWithCommas }}

                    div.userMetric
                        div.userMetricTitle PRACTICES
                        div.userMetricTotal {{ meditationsMeditated | numberWithCommas }}

            v-flex(xs12 lg4)
                div.journalHeader

                    // Title
                    title-component(
                        :title="$t('journal.list.title')"
                        slot="title"
                        type="h2"
                    )

                    // Note
                    note-component.mb-3(:saveCallback="saveCallback")

                div(v-if="!list.length") {{ $t('journal.list.noItems') }}

                // Records
                record-component(v-for="item in list" :key="item.id" :item="item" :showShareButton="showShareButton")

                div.text-xs-center.mt-3

                    // Navigate to Journal button
                    div.journalMoreButton( @click="moreButtonAction")
                        v-icon(color="white") more_horiz
                        div  See All

</template>

<script>
    import Layout from '../Layout/Layout';
    import { MemberPeriods } from './Periods';
    import Widgets from './Widgets';
    import Note from '~components/Note';
    import Range from '~components/Range';
    import Record from '~components/Record';
    import Select from '~components/Select';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import VueTypes from 'vue-types';
    import sessions from '~api/sessions';
    import numberWithCommas from '~filters/numberWithCommas';

    export default {
        filters: {
            numberWithCommas
        },
        components: {
            Layout,
            Periods: MemberPeriods,
            Widgets,
            NoteComponent: Note,
            RecordComponent: Record,
            TitleComponent: Title,
            SelectComponent: Select,
            SeparatorComponent: Separator,
            RangeComponent: Range
        },
        props: {
            id: VueTypes.string.def('')
        },
        data() {
            return {
                depts: []
            };
        },
        computed: {
            ...mapFields('statistics', ['filter']),
            ...mapGetters('statistics', [
                'counter',
                'views',
                'userName',
                'period',
                'minutesMeditated',
                'meditationsMeditated'
            ]),
            ...mapGetters('auth', ['user', 'showShareButton']),
            ...mapGetters('records', ['list']),

            /**
             * Check screen resolution.
             * @returns {boolean}
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        async created() {
            this.updateRange(this.id);
            this.toggleIsShort();
            this.getShortList();
        },
        beforeDestroy() {
            this.toggleIsShort();
        },
        methods: {
            ...mapActions('statistics', ['setRange', 'updateRange']),
            ...mapActions('records', ['getShortList', 'toggleIsShort']),

            /**
             * Filter callback
             */
            filterCallback(e) {
                this.filter[e.name] = e.value;
                if (e.name === 'businessId') {
                    this.filter.department = null;
                }
                this.updateRange(this.id);
            },

            async saveCallback(viewData) {
                await sessions.setWatched(
                    process.env.VUE_APP_JOURNAL_SESSION_ID
                );
                await sessions.saveWatchedTime(viewData);

                this.updateRange();
                this.$refs.widgets.getWidgetsInfo();
            },

            /**
             * Date picker range callback
             */
            rangeCallback(e) {
                if (this.id) return this.setRange({ ...e, id: this.id });
                return this.setRange(e);
            },

            /**
             * Navigate to Journal page
             * @returns {*}
             */
            moreButtonAction() {
                return this.$router.push({ name: 'dashboard.journal' });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl"

    .dailyActivity
        font-size: 48px

    .chartWrapper
        padding: 16px
        border-radius: 10px
        background: rgba(255, 255, 255, 0.1)
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.1)

    .userName
        color: $theme.action

    .journalHeader
        display: flex
        justify-content: space-between
        align-items: center

    .journalMoreButton
        text-align: center
        text-transform: uppercase

    i
        font-size: 32px
        line-height: 15px

    .userMetrics
        display: flex
        align-items: center

    .userMetricTitle
        font-size: 13px
        text-transform: uppercase

    .userMetricTotal
        font-size: 62px
        font-weight: bold

    .userMetric
        width: 50%
        text-align: center

    .userControls
        display: flex

    .userControlsSelector
        display: flex
        align-items: center

    @media screen and (max-width: $grid-breakpoints.lg - 1)
        .mobileDirection
            flex-direction: column-reverse

    @media screen and (max-width: $grid-breakpoints.sm - 1)

        .userControls
            flex-direction: column

            > div
                margin-bottom: 5px
</style>
